var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMalaysia = function SvgMalaysia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Malaysia_svg__a",
    width: 182,
    height: 182,
    x: 9,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.909 9.09H9.091v181.82h181.818V9.091Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#Malaysia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D82535",
    d: "M53.316 21.986h93.375c-13.651-8.189-29.62-12.895-46.692-12.895s-33.041 4.707-46.683 12.895"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M36.461 34.994h127.077a91.661 91.661 0 0 0-16.855-13.008H53.316a91.285 91.285 0 0 0-16.855 13.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82535",
    d: "M25.435 47.985h149.133a91.7 91.7 0 0 0-11.028-13H36.463a91.709 91.709 0 0 0-11.028 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M17.871 60.984h164.26a91.52 91.52 0 0 0-7.564-12.999H25.435a89.987 89.987 0 0 0-7.564 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82535",
    d: "M12.869 73.993h174.254a90.704 90.704 0 0 0-4.993-13.009H17.87a89.643 89.643 0 0 0-5.002 13.009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M10.019 86.992h179.959a90.4 90.4 0 0 0-2.848-13H12.867a89.44 89.44 0 0 0-2.848 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82535",
    d: "M9.09 100h181.82c0-4.42-.321-8.762-.929-13.008H10.02A91.74 91.74 0 0 0 9.09 100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M10.02 112.999h179.96a91.59 91.59 0 0 0 .929-12.999H9.091c0 4.411.321 8.753.93 12.999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82535",
    d: "M12.867 126.007h174.255a89.597 89.597 0 0 0 2.848-13.008H10.019a91.943 91.943 0 0 0 2.848 13.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M17.862 139.007H182.13a90.573 90.573 0 0 0 4.993-13H12.869a90.49 90.49 0 0 0 4.993 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82535",
    d: "M25.434 152.006h149.133a90.911 90.911 0 0 0 7.572-13.008H17.862a91.372 91.372 0 0 0 7.572 13.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M36.463 165.005H163.54a92.147 92.147 0 0 0 11.028-12.999H25.435a91.628 91.628 0 0 0 11.028 12.999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D82535",
    d: "M53.299 178.005H146.7a91.425 91.425 0 0 0 16.838-13H36.461a91.418 91.418 0 0 0 16.838 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M146.699 178.005h-93.4c13.65 8.189 29.628 12.904 46.7 12.904 17.072 0 33.05-4.715 46.7-12.904"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313C91",
    d: "M10.02 112.999h107.408V10.767a91.357 91.357 0 0 0-17.419-1.676C49.791 9.09 9.091 49.79 9.091 100c0 4.411.321 8.753.93 12.999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5D716",
    d: "M31.944 60.984c0-14.545 11.81-26.346 26.347-26.346a26.25 26.25 0 0 1 13.78 3.9 29.969 29.969 0 0 0-20.05-7.66 29.923 29.923 0 0 0-16.178 4.715 91.197 91.197 0 0 0-11.992 14.745 30.083 30.083 0 0 0-1.945 10.646c0 16.656 13.495 30.115 30.115 30.115 7.685 0 14.71-2.917 20.05-7.659a26.25 26.25 0 0 1-13.78 3.9c-14.537 0-26.347-11.802-26.347-26.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5D716",
    d: "m92.166 60.984 14.415-5.574-15.405 1.233 10.569-11.29-13.356 7.79L93 38.398l-8.65 12.809-2.222-15.31-1.607 10.968-.451 3.16-.182 1.182-8.65-12.809 4.629 14.745-13.356-7.79 10.568 11.29-15.413-1.233 14.432 5.574-14.432 5.584 15.414-1.233-10.568 11.323 13.355-7.824-4.629 14.754 8.65-12.808.182 1.198.451 3.143 1.607 10.985L84.35 70.78 93 83.588l-4.611-14.754 13.356 7.824-10.569-11.323 15.405 1.233-14.415-5.584"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 0,
    strokeWidth: 3,
    d: "M190.909 100c0-50.208-40.701-90.91-90.909-90.91C49.792 9.09 9.09 49.793 9.09 100s40.702 90.909 90.91 90.909 90.909-40.701 90.909-90.909Z"
  })));
};
export default SvgMalaysia;